import { AxiosError, Cancel } from 'axios';
import RequestError from 'classes/RequestError';

const handleError = (error: AxiosError | Cancel) =>
  Promise.reject<RequestError>(new RequestError(error));

export default handleError;
